import { createSlice } from '@reduxjs/toolkit';
import { portalApi } from '../api/portalApi';

// Re-export RTK Query hook for direct component use
export { useGetZoneCountQuery } from '../api/portalApi';

/**
 * Backward-compatible thunk wrapper.
 */
export const fetchZones = (jobId) => (dispatch) => {
  return dispatch(
    portalApi.endpoints.getZoneCount.initiate(jobId, { forceRefetch: false })
  );
};

const initialState = {
  zones: null,
  status: 'idle',
  error: null,
};

// Create zoneCount slice
const zoneCountSlice = createSlice({
  name: 'zoneCount',
  initialState,
  reducers: {
    clearZones: (state) => {
      state.zones = null;
      state.status = 'idle';
      state.error = null;
    },
    setZones: (state, action) => {
      state.zones = action.payload;
      state.status = 'succeeded';
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // ── RTK Query: getZoneCount ─────────────────────────────────────────
      .addMatcher(
        portalApi.endpoints.getZoneCount.matchPending,
        (state) => { state.status = 'loading'; }
      )
      .addMatcher(
        portalApi.endpoints.getZoneCount.matchFulfilled,
        (state, action) => {
          state.status = 'succeeded';
          state.zones = action.payload;
        }
      )
      .addMatcher(
        portalApi.endpoints.getZoneCount.matchRejected,
        (state, action) => {
          state.status = 'failed';
          state.error = action.error?.message ?? 'Failed to fetch zones';
        }
      );
  },
});

export const { clearZones, setZones } = zoneCountSlice.actions;
export default zoneCountSlice.reducer;
